import { onBeforeMount as p, getCurrentInstance as s } from "vue";
import { track as a } from "@ds/tracking/tracking";
import { isDev as d } from "../utils/isDev.js";
function D(r, c = "deprecation-warning") {
  const { deadline: e, reason: t, replacementName: i, props: m } = r || {};
  p(() => {
    const o = s()?.type.name, n = !!(e && new Date(e).getTime() < Date.now());
    if (!o)
      throw new Error(
        "useDeprecation must be called from within a Vue component."
      );
    a({
      action: c,
      context: {
        deadline: e,
        deadlinePassed: n,
        name: o,
        reason: t,
        replacementName: i,
        props: m
      }
    }), d() && n && a({
      action: "remove-deprecated-export",
      context: {
        deadline: e,
        name: o,
        reason: t
      }
    });
  });
}
export {
  D as useDeprecation
};
